module.exports = __webpack_public_path__ + "assets/checkmark small-9c8fe0747885f8d07b1252af912b48bd.svg";